// Lucide icon: calendar-check (https://lucide.dev/icons/calendar-check)
import { CalendarCheck } from 'lucide-react'

import { IconComponentStyled } from '../styles/IconComponentStyled'
import { type IIconComponentProps } from '../types'

export const IconBlanketPo = (props: IIconComponentProps) => {
  return (
    <IconComponentStyled {...props}>
      <CalendarCheck />
    </IconComponentStyled>
  )
}
